import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import type MealCategory from './meal-category';

@JsonApiResource({
  type: 'production-line',
})
export default class ProductionLine extends BaseEntity {
  @JsonApiProperty({ type: 'object' }) hhcRoutesNumbers: number[];
  @JsonApiRelationship('meal-category') mealCategories: MealCategory[];

  constructor(
    id?: BaseEntity['id'],
    public name: string = '',
    hhcRoutesNumbers: number[] = [],
    mealCategories: MealCategory[] = []
  ) {
    super();
    this.id = id;
    this.hhcRoutesNumbers = hhcRoutesNumbers;
    this.mealCategories = mealCategories;
  }
}
